const fillExtraFoodIdsInCombos = (combos) => {
  combos.forEach((combo, cIndex) => {
    const comboItemsMap = {}
    combo.items.forEach(orderItem => {
      comboItemsMap[orderItem.foodId] = orderItem
    })

    const extraFoodIdsMap = {}

    const orderItemsWithExtras =
      combo.items.map(orderItem => {
        const result = {
          ...orderItem,
          extraFoods:
            orderItem.extraFoodIds?.map(extraFoodId => {
              extraFoodIdsMap[extraFoodId] = true

              return comboItemsMap[extraFoodId]
            }) || []
        }

        delete result.extraFoodIds

        return result
      })

    const filledComboItems =
      orderItemsWithExtras.filter(orderItemsWithExtra =>
        !extraFoodIdsMap[orderItemsWithExtra.foodId]
      )

    combos[cIndex] = {
      ...combo,
      items: filledComboItems
    }
  })

  return combos
}

const groupOrderCombos = (order) => {
  const comboOrderItems =
    order.items.filter(item => !!item.comboSet)

  const combos = []

  comboOrderItems.forEach(comboOrderItem => {
    const comboSet = comboOrderItem.comboSet

    const newItem = {
      _id: comboSet.couponData._id,
      addAmount: comboSet.couponData.addAmount,
      foodDiscount: comboOrderItem.foodDiscount,
      foodId: comboOrderItem.foodId,
      foodImageCover: comboOrderItem.foodImageCover,
      foodName: comboOrderItem.foodName,
      option: comboOrderItem.option,
      optionId: comboOrderItem.option._id,
      optionName: comboOrderItem.option.name,
      isSimple: comboOrderItem.isSimple,
      extraFoodIds: comboOrderItem.extraFoodIds,
      quantity: comboOrderItem.quantity,
      taxInclusive: comboOrderItem.taxInclusive,
      taxItems: comboOrderItem.taxItems,
      orderItemId: comboOrderItem._id,
      salePrice: comboOrderItem.salePrice,
      orderItemSpecifications: comboOrderItem.orderItemSpecifications
    }

    const comboIndex =
      comboSet.groupNumber - 1

    const previousComboItems =
      combos[comboIndex]?.items || []

    const items =
      [...previousComboItems, newItem]

    combos[comboIndex] = {
      items,
      name: comboSet.name,
      code: comboSet.code,
      groupNumber: comboSet.groupNumber,
      comboSetSalePrice: comboSet.comboSetSalePrice
    }
  })

  combos.forEach((combo, comboIndex) => {
    const totalAddedAmount =
      combo.items.reduce((t, comboItem) =>
        t += comboItem.addAmount
        , 0
      )

    const comboSetSalePrice =
      combo.comboSetSalePrice +
      totalAddedAmount

    const totalItemsSalePrice =
      combo.items.reduce((t, comboItem) =>
        t += comboItem.salePrice * comboItem.quantity
        , 0
      )

    const comboDiscount =
      totalItemsSalePrice - comboSetSalePrice

    combos[comboIndex] = {
      ...combo,
      comboDiscount,
      comboSetSalePrice
    }
  })

  const result =
    fillExtraFoodIdsInCombos(combos)

  return result
}

export default groupOrderCombos